<div (click)="$event.stopPropagation()">
  <div #customButton>
    <ng-content select="[menu-button]" />
  </div>
  @if (!customButton.hasChildNodes()) {
    <button
      pButton
      class="p-button p-button-primary p-button-outlined icon-only p-2"
      [ngClass]="buttonClass"
      [disabled]="isLoading"
      (click)="toggleMenu($event)">
      @if (!menu.overlayVisible) {
        <shared-icon icon="menu-dots-vertical" [height]="iconsHeight" [width]="iconsWidth" />
      }
      @if (menu.overlayVisible) {
        <shared-icon icon="cross" [height]="iconsHeight" [width]="iconsWidth" />
      }
    </button>
  }
  <p-popover #menu [dismissable]="false">
    <div class="menu-container">
      @for (item of iconMenuItems; track item) {
        <div class="menu-item" (click)="item.command(null); menu.hide()">
          @if (item.icon) {
            <shared-icon [icon]="item.icon" height="1rem" width="1rem" />
          }
          {{ item.label }}
        </div>
      }
    </div>
  </p-popover>

  @if (menu.overlayVisible) {
    <div (click)="menu.hide()" class="custom-popover-mask"></div>
  }
</div>
